import { useState } from "react";

import { adminApi, type CostResponse } from "../api";

export function Cost(): JSX.Element {
  const [projectId, setProjectId] = useState("");
  const [data, setData] = useState<CostResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function load(): Promise<void> {
    if (!projectId) return;
    setBusy(true);
    setError(null);
    try {
      setData(await adminApi.get<CostResponse>(`/api/v1/admin/cost/${projectId}`));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <h2 className="page-title">💰 Cost</h2>
      <p className="page-subtitle">Per-project ₹ breakdown + optimizer recommendations.</p>
      {error && <div className="error-banner">{error}</div>}
      <div className="form-row">
        <label htmlFor="project">Project ID</label>
        <input id="project" value={projectId} onChange={(e) => setProjectId(e.target.value)} />
        <button disabled={busy} onClick={load}>
          Load
        </button>
      </div>
      {data && (
        <>
          <div className="kpi-row">
            <div className="kpi">
              <div className="value">₹{data.hot_cost_inr.toFixed(2)}</div>
              <div className="label">Hot / month</div>
            </div>
            <div className="kpi">
              <div className="value">₹{data.cold_cost_inr.toFixed(2)}</div>
              <div className="label">Cold / month</div>
            </div>
            <div className="kpi">
              <div className="value">₹{data.backup_cost_inr.toFixed(2)}</div>
              <div className="label">Backup / month</div>
            </div>
            <div className="kpi">
              <div className="value">₹{data.total_cost_inr.toFixed(2)}</div>
              <div className="label">Total / month</div>
            </div>
          </div>
          <div className="panel">
            <h3>Recommendations</h3>
            {data.recommendations.length === 0 && (
              <p className="page-subtitle">No savings recommendations right now.</p>
            )}
            <table>
              <thead>
                <tr>
                  <th>Object</th>
                  <th>Action</th>
                  <th>Monthly savings</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {data.recommendations.map((r) => (
                  <tr key={r.object_id}>
                    <td>{r.object_id.slice(0, 8)}…</td>
                    <td>{r.action}</td>
                    <td>₹{r.monthly_savings_inr.toFixed(2)}</td>
                    <td>{r.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
